import React from "react";
import { timerValue } from "../../utilities/currentDate";

import "./Room.css";

const TimerValues = ({ setMinutes, setSeconds }) => {

    const handlerTimeStamp = (value) => {
        setSeconds(0);

        if (value) {
            const minutes = parseInt(value);

            setMinutes(minutes);
        }
    };

    return (
        <div className="timer_value_container mt-2">
            {timerValue.map((value, index) => (
                <h4 className="timer_value_style" key={index} onClick={() => handlerTimeStamp(value)}>{value}</h4>
            ))}
            <span className="paragraph_minute_second">MINUTOS</span>
        </div>
    );
};

export default TimerValues;